import styled from 'styled-components'

export const Container = styled.div`
  .color-marker-label {
    color: #ffffff;
    mix-blend-mode: exclusion;
  }
`
